import { Box } from '@mui/material';
import DocHead from 'components/DocHead/DocHead';
import Footer from 'components/Footer/Footer';
import Header from 'components/Header/Header';
import LandingAuth from 'components/LandingAuth/LandingAuth';
import MobileWarning from 'components/MobileWarning/MobileWarning';
import dynamic from 'next/dynamic';

const SettingsControls = dynamic(() => import('components/SettingsControls/SettingsControls'));

export default function Main({ children }: MainProps) {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
            <DocHead />
            <Header>{process.env.NEXT_PUBLIC_REGISTRATION ? <LandingAuth /> : null}</Header>
            <Box
                data-testid="main-content-wrap"
                sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}
            >
                <MobileWarning minWidth={800}>
                    <Box component="main" data-testid="main-content" sx={{ flex: 1 }}>
                        {children}
                        {process.env.NEXT_PUBLIC_ADMIN ? <SettingsControls /> : null}
                    </Box>
                </MobileWarning>
            </Box>
            <Footer />
        </Box>
    );
}
